import React from "react";
import StatsSection from "./StatsSection";
export default function CountingValues() {

  return (
    <div className="3xl:max-w-[82%] w-[95%] mx-auto">
      <StatsSection />
     
    </div>
  );
}